// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"CurrencyComboBox_selectWrapper__tq3XX"};